





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MentoringCard extends Vue {
  @Prop({ type: Object, default: null })
  readonly item!: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/components/card/MentoringCard.vue